<div class="d-block d-sm-none">
    <nav class="navbar navbar-expand-lg fondoAmarillo">
        <div class="container-fluid">
        <a class="navbar-brand" href="#">
            <img src="assets/img/auri.png" height="50px">
        </a>
        <button class="navbar-toggler ml-auto custom-toggler" 
                    type="button" 
                    data-toggle="collapse" 
                    data-target="#navbarSupportedContent"> 
                <span class="navbar-toggler-icon">Menú</span> 
            </button> 
    
        <div class="collapse navbar-collapse" id="navbarSupportedContent">
            <ul class="navbar-nav ml-auto">

                <li class="nav-item">
                    <a href="clientes">
                        <svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-person-fill" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" d="M3 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1H3zm5-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"/>
                          </svg>
                        Clientes</a>
                </li>
                <li class="nav-item">
                    <a href="grupos">
                    <svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-people-fill" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" d="M7 14s-1 0-1-1 1-4 5-4 5 3 5 4-1 1-1 1H7zm4-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm-5.784 6A2.238 2.238 0 0 1 5 13c0-1.355.68-2.75 1.936-3.72A6.325 6.325 0 0 0 5 9c-4 0-5 3-5 4s1 1 1 1h4.216zM4.5 8a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5z"/>
                        </svg>
                    Grupos</a>
                </li>

                <li class="nav-item">
                    <a href="reporte-produccion">Reporte Producción</a>
                </li>

                <li class="nav-item" *ngIf="datosCliente.acceso_pagos == 1">
                    <a href="reporte-ventas">Reporte Ventas</a>
                </li>

                <li class="nav-item">
                    <a href="reporte-registros">Reporte Registros</a>
                </li>

                <li class="nav-item" *ngIf="datosCliente.acceso_pagos == 1">
                    <a href="reporte-grupos">Reporte Registros por Grupo</a>
                </li>

                <li class="nav-item">
                    <a href="gastos">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-coin" viewBox="0 0 16 16">
                            <path d="M5.5 9.511c.076.954.83 1.697 2.182 1.785V12h.6v-.709c1.4-.098 2.218-.846 2.218-1.932 0-.987-.626-1.496-1.745-1.76l-.473-.112V5.57c.6.068.982.396 1.074.85h1.052c-.076-.919-.864-1.638-2.126-1.716V4h-.6v.719c-1.195.117-2.01.836-2.01 1.853 0 .9.606 1.472 1.613 1.707l.397.098v2.034c-.615-.093-1.022-.43-1.114-.9H5.5zm2.177-2.166c-.59-.137-.91-.416-.91-.836 0-.47.345-.822.915-.925v1.76h-.005zm.692 1.193c.717.166 1.048.435 1.048.91 0 .542-.412.914-1.135.982V8.518l.087.02z"/>
                            <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                            <path d="M8 13.5a5.5 5.5 0 1 1 0-11 5.5 5.5 0 0 1 0 11zm0 .5A6 6 0 1 0 8 2a6 6 0 0 0 0 12z"/>
                          </svg>
                        Gastos</a>
                </li>
    
                <li class="nav-item">
                    <a href="usuarios">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-person-plus-fill" viewBox="0 0 16 16">
                            <path d="M1 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1H1zm5-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"/>
                            <path fill-rule="evenodd" d="M13.5 5a.5.5 0 0 1 .5.5V7h1.5a.5.5 0 0 1 0 1H14v1.5a.5.5 0 0 1-1 0V8h-1.5a.5.5 0 0 1 0-1H13V5.5a.5.5 0 0 1 .5-.5z"/>
                          </svg>
                        Usuarios</a>
                </li>
                <li class="nav-item">
                    <a href="#homeSubmenu" data-toggle="collapse" aria-expanded="false" class="dropdown-toggle">
                        <svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-folder-fill" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" d="M9.828 3h3.982a2 2 0 0 1 1.992 2.181l-.637 7A2 2 0 0 1 13.174 14H2.826a2 2 0 0 1-1.991-1.819l-.637-7a1.99 1.99 0 0 1 .342-1.31L.5 3a2 2 0 0 1 2-2h3.672a2 2 0 0 1 1.414.586l.828.828A2 2 0 0 0 9.828 3zm-8.322.12C1.72 3.042 1.95 3 2.19 3h5.396l-.707-.707A1 1 0 0 0 6.172 2H2.5a1 1 0 0 0-1 .981l.006.139z"/>
                          </svg>
                        Catálogos</a>
                        
                <ul class="collapse list-unstyled" id="homeSubmenu">
                
                <li  class="nav-item">
                    <a href="productos">Productos</a>
                </li>
                
                <li  class="nav-item">
                    <a href="paquetes">Paquetes</a>
                </li>
                <li  class="nav-item">
                    <a href="instituciones">Escuelas</a>
                </li>
                <li  class="nav-item">
                    <a href="carreras">Carreras</a>
                </li>
                <li  class="nav-item">
                    <a href="molduras">Molduras</a>
                </li>

                <li  class="nav-item">
                    <a href="fondos-molduras">Fondos Molduras</a>
                </li>

                <li  class="nav-item">
                    <a href="placas">Placas</a>
                </li>
                <li  class="nav-item">
                    <a href="dedicatorias">Dedicatorias</a>
                </li>
                <li  class="nav-item">
                    <a href="anillos">Anillos</a>
                </li>
                <li  class="nav-item">
                    <a href="precio-anillos">Precio Anillos</a>
                </li>
                <li  class="nav-item">
                    <a href="codigos-descuento">Códigos de Descuento</a>
                </li>
                <li  class="nav-item">
                    <a href="fondos">Fondos</a>
                </li>
                <li  class="nav-item">
                    <a href="sesion-tematica">Sesiones Temáticas</a>
                </li>
                <li  class="nav-item">
                    <a href="estolas">Estolas</a>
                </li>
                <li  class="nav-item">
                    <a href="colores">Colores</a>
                </li>
                <li  class="nav-item">
                    <a href="municipios">Municipios</a>
                </li>
                <li  class="nav-item">
                    <a href="viajes">Viajes</a>
                </li>

                <li  class="nav-item">
                    <a href="fiestas">Fiestas</a>
                </li>
                
                <li class="nav-item">
                    <a href="grupos-v2">Grupos V2</a>
                </li>

               </ul>
               </li>
                <li class="nav-item">
                    <a href="#homeSubmenuV2" data-toggle="collapse" aria-expanded="false" class="dropdown-toggle">
                        <svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-collection" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" d="M2.5 3h11A1.5 1.5 0 0 1 15 4.5v9A1.5 1.5 0 0 1 13.5 15h-11A1.5 1.5 0 0 1 1 13.5v-9A1.5 1.5 0 0 1 2.5 3zM2 4.5A.5.5 0 0 1 2.5 4h11a.5.5 0 0 1 .5.5V6H2V4.5zm0 2.5v6.5a.5.5 0 0 0 .5.5h11a.5.5 0 0 0 .5-.5V7H2z"/>
                            <path fill-rule="evenodd" d="M4 1h8a1 1 0 0 1 1 1v1h-1V2H4v1H3V2a1 1 0 0 1 1-1z"/>
                        </svg>
                        V2</a>
                        
                <ul class="collapse list-unstyled" id="homeSubmenuV2">
                
                <li  class="nav-item">
                    <a href="v2/familias">Familias v2</a>
                </li>
                
                <li  class="nav-item">
                    <a href="v2/paquetes">Paquetes v2</a>
                </li>
                <li  class="nav-item">
                    <a href="v2/productos">Productos v2</a>
                </li>
                <li  class="nav-item">
                    <a href="v2/variaciones">Variaciones v2</a>
                </li>
               </ul>
               </li>
                
                <li class="nav-item"><a (click)="closeSesion()">
                    <svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-lock" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" d="M11.5 8h-7a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h7a1 1 0 0 0 1-1V9a1 1 0 0 0-1-1zm-7-1a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h7a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-7zm0-3a3.5 3.5 0 1 1 7 0v3h-1V4a2.5 2.5 0 0 0-5 0v3h-1V4z"/>
                      </svg>
                    Cerrar Sesión</a></li>
               
            </ul>
        </div>
        </div>
    </nav>
</div>

<div class="wrapper d-none d-sm-block">
    <!-- Sidebar -->
    <nav id="sidebar">
        <div class="sidebar-header">
            <img src="assets/img/auri.png" width="100%">
        </div>

        <ul class="list-unstyled components">
            <li *ngIf="tipoUsuario =='1'">
                <a href="clientes">
                    <svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-person-fill" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" d="M3 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1H3zm5-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"/>
                      </svg>
                    Clientes</a>
            </li>
            <li *ngIf="tipoUsuario =='1' || tipoUsuario == '2'">
                <a href="grupos" >
                    <svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-people-fill" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" d="M7 14s-1 0-1-1 1-4 5-4 5 3 5 4-1 1-1 1H7zm4-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm-5.784 6A2.238 2.238 0 0 1 5 13c0-1.355.68-2.75 1.936-3.72A6.325 6.325 0 0 0 5 9c-4 0-5 3-5 4s1 1 1 1h4.216zM4.5 8a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5z"/>
                      </svg>
                    Grupos</a>
            </li>

            <li *ngIf="tipoUsuario =='1' || tipoUsuario == '2'">
                <a href="alertas">
                    <svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-person-fill" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" d="M3 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1H3zm5-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"/>
                      </svg>
                    Alertas</a>
            </li> 
            <li *ngIf="tipoUsuario =='1'">
                <a href="#homeSubmenu" data-toggle="collapse" aria-expanded="false" class="dropdown-toggle">
                    <svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-folder-fill" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" d="M9.828 3h3.982a2 2 0 0 1 1.992 2.181l-.637 7A2 2 0 0 1 13.174 14H2.826a2 2 0 0 1-1.991-1.819l-.637-7a1.99 1.99 0 0 1 .342-1.31L.5 3a2 2 0 0 1 2-2h3.672a2 2 0 0 1 1.414.586l.828.828A2 2 0 0 0 9.828 3zm-8.322.12C1.72 3.042 1.95 3 2.19 3h5.396l-.707-.707A1 1 0 0 0 6.172 2H2.5a1 1 0 0 0-1 .981l.006.139z"/>
                      </svg>
                    Catálogos</a>
            <ul class="collapse list-unstyled" id="homeSubmenu">
                    <li>
                        <a href="productos">Productos</a>
                    </li>
                    
                    <li>
                        <a href="paquetes">Paquetes</a>
                    </li>

                    <li>
                        <a href="agradecimientos">Agradecimientos</a>
                    </li>


                    <li>
                        <a href="diplomas">Diplomas</a>
                    </li>
                    <li>
                        <a href="instituciones">Escuelas</a>
                    </li>
                    <li>
                        <a href="carreras">Carreras</a>
                    </li>
                    <li>
                        <a href="molduras">Molduras</a>
                    </li>

                    <li>
                        <a href="fondos-molduras">Fondos Molduras</a>
                    </li>

                    <li>
                        <a href="placas">Placas</a>
                    </li>
                    <li>
                        <a href="dedicatorias">Dedicatorias</a>
                    </li>
                    <li>
                        <a href="anillos">Anillos</a>
                    </li>
                    <li>
                        <a href="precio-anillos">Precio Anillos</a>
                    </li>
                    <li>
                        <a href="codigos-descuento">Códigos de Descuento</a>
                    </li>
                    <li>
                        <a href="fondos">Fondos</a>
                    </li>
                    <li>
                        <a href="sesion-tematica">Sesiones Temáticas</a>
                    </li>
                    <li>
                        <a href="estolas">Estolas</a>
                    </li>
                    <li>
                        <a href="colores">Colores</a>
                    </li>
                    <li>
                        <a href="municipios">Municipios</a>
                    </li>
                    <li>
                        <a href="viajes">Viajes</a>
                    </li>

                    <li>
                        <a href="fiestas">Fiestas</a>
                    </li>

                    <li>
                        <a href="categorias">Categorías Grupos</a>
                    </li>

                    
                   
                </ul>
            </li> 
            <li *ngIf="tipoUsuario =='1'">
                <a href="#homeSubmenuV2" data-toggle="collapse" aria-expanded="false" class="dropdown-toggle">
                    <svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-collection" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" d="M2.5 3h11A1.5 1.5 0 0 1 15 4.5v9A1.5 1.5 0 0 1 13.5 15h-11A1.5 1.5 0 0 1 1 13.5v-9A1.5 1.5 0 0 1 2.5 3zM2 4.5A.5.5 0 0 1 2.5 4h11a.5.5 0 0 1 .5.5V6H2V4.5zm0 2.5v6.5a.5.5 0 0 0 .5.5h11a.5.5 0 0 0 .5-.5V7H2z"/>
                        <path fill-rule="evenodd" d="M4 1h8a1 1 0 0 1 1 1v1h-1V2H4v1H3V2a1 1 0 0 1 1-1z"/>
                    </svg>
                    V2</a>
                <ul class="collapse list-unstyled" id="homeSubmenuV2">
                    <li>
                        <a href="v2/familias">Familias v2</a>
                    </li>
                    <li>
                        <a href="v2/paquetes">Paquetes v2</a>
                    </li>
                    <li>
                        <a href="v2/productos">Productos v2</a>
                    </li>
                    <li>
                        <a href="v2/variaciones">Variaciones v2</a>
                    </li>
                </ul>
            </li>
            <li *ngIf="tipoUsuario =='1'">
                <a href="#homeSubmenuReportes" data-toggle="collapse" aria-expanded="false" class="dropdown-toggle">
                    <svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-file-earmark-bar-graph-fill" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" d="M2 2a2 2 0 0 1 2-2h5.293A1 1 0 0 1 10 .293L13.707 4a1 1 0 0 1 .293.707V14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2zm7.5 1.5v-2l3 3h-2a1 1 0 0 1-1-1zm.5 10a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-6a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v6zm-2.5.5a.5.5 0 0 1-.5-.5v-4a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-.5.5h-1zm-3 0a.5.5 0 0 1-.5-.5v-2a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5h-1z"/>
                      </svg>
                    Reportes</a>
                <ul class="collapse list-unstyled" id="homeSubmenuReportes">
                    <li *ngIf="datosCliente.acceso_pagos == 1">
                        <a href="dashboard">Dashboard</a>
                    </li>
                    <li>
                        <a href="reporte-produccion">Reporte Producción</a>
                    </li>

                    <li *ngIf="datosCliente.acceso_pagos == 1">
                        <a href="reporte-ventas">Reporte Ventas</a>
                    </li>

                    <li>
                        <a href="reporte-registros">Reporte Registros</a>
                    </li>

                    <li *ngIf="datosCliente.acceso_pagos == 1">
                        <a href="reporte-grupos">Reporte Registros por Grupo</a>
                    </li>

                    <li *ngIf="datosCliente.acceso_pagos == 1">
                        <a href="flujo-efectivo">Flujo de efectivo</a>
                    </li>
                </ul>
            </li>

            <li *ngIf="tipoUsuario =='1'">
                <a href="#homeSubmenuCompras" data-toggle="collapse" aria-expanded="false" class="dropdown-toggle">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-coin" viewBox="0 0 16 16">
                        <path d="M5.5 9.511c.076.954.83 1.697 2.182 1.785V12h.6v-.709c1.4-.098 2.218-.846 2.218-1.932 0-.987-.626-1.496-1.745-1.76l-.473-.112V5.57c.6.068.982.396 1.074.85h1.052c-.076-.919-.864-1.638-2.126-1.716V4h-.6v.719c-1.195.117-2.01.836-2.01 1.853 0 .9.606 1.472 1.613 1.707l.397.098v2.034c-.615-.093-1.022-.43-1.114-.9H5.5zm2.177-2.166c-.59-.137-.91-.416-.91-.836 0-.47.345-.822.915-.925v1.76h-.005zm.692 1.193c.717.166 1.048.435 1.048.91 0 .542-.412.914-1.135.982V8.518l.087.02z"/>
                        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                        <path d="M8 13.5a5.5 5.5 0 1 1 0-11 5.5 5.5 0 0 1 0 11zm0 .5A6 6 0 1 0 8 2a6 6 0 0 0 0 12z"/>
                      </svg>
                    Compras</a>
                
                <ul class="collapse list-unstyled" id="homeSubmenuCompras">
                    <li>
                        <a href="gastos">Gastos</a>
                    </li>
                    <!-- <li>
                        <a href="flujo-efectivo">Flujo Efectivo</a>
                    </li> -->
        
                    <li>
                        <a href="insumos">Insumos</a>
                    </li>
        
                    <li>
                        <a href="proveedores">Proveedores</a>
                    </li>
                </ul>
            </li>

            <li *ngIf="tipoUsuario =='1'">
                <a href="contenido">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-play-btn" viewBox="0 0 16 16">
                        <path d="M6.79 5.093A.5.5 0 0 0 6 5.5v5a.5.5 0 0 0 .79.407l3.5-2.5a.5.5 0 0 0 0-.814l-3.5-2.5z"/>
                        <path d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4zm15 0a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4z"/>
                      </svg>
                    Contenido</a>
            </li>
            

            <li *ngIf="tipoUsuario =='1'">
                <a href="usuarios">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-person-plus-fill" viewBox="0 0 16 16">
                        <path d="M1 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1H1zm5-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"/>
                        <path fill-rule="evenodd" d="M13.5 5a.5.5 0 0 1 .5.5V7h1.5a.5.5 0 0 1 0 1H14v1.5a.5.5 0 0 1-1 0V8h-1.5a.5.5 0 0 1 0-1H13V5.5a.5.5 0 0 1 .5-.5z"/>
                      </svg>
                    Usuarios</a>
            </li>
            
            <li><a (click)="closeSesion()">
                <svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-lock" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" d="M11.5 8h-7a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h7a1 1 0 0 0 1-1V9a1 1 0 0 0-1-1zm-7-1a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h7a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-7zm0-3a3.5 3.5 0 1 1 7 0v3h-1V4a2.5 2.5 0 0 0-5 0v3h-1V4z"/>
                  </svg>
                Cerrar Sesión</a></li>
        </ul>
    </nav>

</div>
